import { IHeaderParams } from "ag-grid-community";
import React from "react";

import { IgTypography } from "@intelligems/ig-theme";
import { Grid, styled } from "@mui/material";
import { HeaderParams } from "@src/components/MainApp/SharedProductPicker/types";
import { useSelector } from "@src/store";
import {
  getProductPickerFilters,
  getProductPickerLoadedCount,
  getProductPickerProductCount,
} from "@src/store/slices/productPicker";
import { ProductPickerSelectedProduct } from "@src/store/slices/productPicker/types";

export const ProductListProductHeader = (
  props: IHeaderParams<ProductPickerSelectedProduct>
) => {
  const count = useSelector(getProductPickerProductCount);
  const loaded = useSelector(getProductPickerLoadedCount);
  const filters = useSelector(getProductPickerFilters);
  const info =
    count !== undefined
      ? !filters.collection_id
        ? ` (${loaded} of ${count})`
        : ` (${loaded} loaded)`
      : "";
  const headerParams = props.column.getColDef().headerComponentParams as
    | HeaderParams
    | undefined;
  return (
    <Grid item sx={headerParams?.sx}>
      <IgTypography>
        Product
        {info}
      </IgTypography>
    </Grid>
  );
};
